<template>
  <div>
    <Loading :loading="this.loading"></Loading>
    <div v-show="!this.loading" class="content-wrapper">
      <div class="container">
        <article>
          <section class="section white-panel pr0 mb2p pb120 pt120">
            <div class="mr16">
              <h2 class="text-center fs15 font-weight-bold">決済で使用したカード情報を<br>登録しますか？</h2>
              <p class="fs12 text-center pt8 mb40">既にご登録いただいている場合は「登録しない」を選択ください。</p>
            <button class="button fs16 mt8 mb24 pd16 radius200" v-bind:disabled="processing" v-on:click="toCardEntry()">登録する</button>
            <button class="button button-gray fs16 mb12" v-on:click="toAppTop()">登録しない</button>
            </div>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>

import Loading from '@/views/v1/Loading'
import gmoCardEntryGetApi from '@/store/Api/gmoCardEntryGet'
import { useGmoPageStore } from '@/store/gmoPage'

export default {
  data () {
    return {
      loading: true,
      processing: false
    }
  },
  props: [
  ],
  methods: {
    async toCardEntry () {
      // [eventTrack]
      this.nativeEVENTSet('GmoCardTourokuKakunin', 'REGISTRATION', 'TAP')

      // 二度押しロック
      this.processing = true
      let isApiError = false

      const postData = {
        // クエリパラメータから取得
        order_id: this.$route.query.order_id
      }

      console.log('*** gmoCardEntryGetApiPost-requestParam ***')
      console.log(postData)

      await gmoCardEntryGetApi.post(
        this.$route.query.authid,
        postData
      ).then(res => {
        const gmoPage = res.data
        // GMOカード編集画面
        const gmoPageStore = useGmoPageStore()
        gmoPageStore.gmoPage = gmoPage
        this.$router.push({ name: 'V1CardEntry' })
      }).catch(e => { // eslint-disable-line no-unused-vars
        console.log('gmoCardEntryGetApiPost-error')
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
        // 二度押しロック解除
        this.processing = false
      })
    },
    toAppTop () {
      // [eventTrack]
      this.nativeEVENTSet('GmoCardTourokuKakunin', 'NOT_REGISTRATION', 'TAP')

      // アプリTOPへ遷移
      this.appHomeBack()
    }
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(false)
    this.loading = false
  },
  components: {
    Loading
  }

}
</script>
